import { render, staticRenderFns } from "./FlyerRowMenu.vue?vue&type=template&id=2196572f&scoped=true"
import script from "./FlyerRowMenu.vue?vue&type=script&lang=js"
export * from "./FlyerRowMenu.vue?vue&type=script&lang=js"
import style0 from "./FlyerRowMenu.vue?vue&type=style&index=0&id=2196572f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2196572f",
  null
  
)

export default component.exports